import "@shoelace-style/shoelace/dist/components/badge/badge.js";

import { html } from "lit";
import { state, customElement, property } from "lit/decorators.js";

import { BaseElement } from "../BaseElement";
import { styles } from "./Warning.style";
import { watch } from "../internal/watch";
import { WarningGroup, WarningLevel } from "../../../models";
import { litIf } from "../LitUtils";
import { WarningTable } from "../../backend/cloud/WarningsTable";
import { DataClient } from "../../DataStore/LocalDataStore";
import { ChangeSet, ChangeSetListener } from "../../DataStore/ChangeSet";
import { DataProvider } from "../../DataStore/DataProvider";

import "./WarningIcon";

@customElement("ds-warning")
export class Warning extends BaseElement implements ChangeSetListener {
    static override styles = [styles];
    @property({ type: String }) warningId?: string;
    @property({ type: Boolean }) showDesc = false;

    @state() protected _title?: string;
    @state() protected _desc?: string;
    @state() protected _group?: WarningGroup;
    @state() protected _level?: WarningLevel;

    private _warnings = this._kernel.dataStore.getSource<WarningTable>("warnings");

    @watch("warningId")
    async _warningIdChanged() {
        this._title = undefined;
        this._desc = undefined;
        if (this.warningId) {
            const w = await this._warnings.read(this.warningId);
            if (w) {
                this._title = w.title;
                this._desc = w.description;
                this._group = w.group;
                this._level = w.level;
            }
        }
    }

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._kernel.dataStore.connectClient(
            new DataClient(this, [{ source: "warnings", paths: [] }])
        );
    }

    public override disconnectedCallback(): void {
        super.disconnectedCallback();
        this._kernel.dataStore.disconnectClient(this);
    }

    onChangeSet(provider: DataProvider, _changeSet: ChangeSet<any>): void {
        if (provider.name === "warnings") {
            this._warningIdChanged();
        }
    }

    override render() {
        return html`<div class="container">
            ${litIf(
                this.showDesc,
                () => html`
                    <div>
                        <ds-warning-icon .level=${this._level}></ds-warning-icon>
                        <span>${this._group} - ${this._title}</span>
                    </div>
                `
            )}
            ${litIf(this.showDesc, () => html`<div><span class="desc">${this._desc}</span></div>`)}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-warning": Warning;
    }
}
